import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardSalesPanelComponent } from 'src/app/components/dashboard-sales-panel/dashboard-sales-panel.component';
import { LoginLogsComponent } from 'src/app/components/login-logs/login-logs.component';
import { OnboardingStatus } from 'src/app/models/AgentModel';
import { DocumentDetails } from 'src/app/models/Distributor';
import { AdminService } from 'src/app/services/admin.service';
import { AgentService } from 'src/app/services/agent.service';
import * as moment from 'moment';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-agent-view',
  templateUrl: './agent-view.component.html',
  styleUrls: ['./agent-view.component.css'],
})
export class AgentViewComponent {
  activeTab: number = 1;
  agentForm: FormGroup;
  companyForm: FormGroup;
  id: number = 0;
  documentsUploadForm: DocumentDetails[] = [];
  editUrl: any;
  canEdit: boolean = false;
  menuId: number = 0;
  menuUrl: string = '';
  userId: string = '';
  agentOnBoardingStatus: OnboardingStatus = {
    ADR_Status : 0,
    BNK_Status : 0,
    EXM_Status : 0,
    IMG_Status : 0,
    KYC_Status : 0,
    PAN_Status : 0,
    QUL_Status : 0,
    TRN_Status : 0,
    TrainingSession1 : 0,
    TrainingSession2 : 0,
    TrainingSession3 : 0,
    TrainingSession4 : 0,
    TrainingSession5 : 0  
  };
  totalLeads: number = 0;
  succeedLeads: number = 0;
  failedLeads: number = 0;
  pendingLeads: number = 0;
  @ViewChild(LoginLogsComponent) loginLogsComponent!: LoginLogsComponent;
  @ViewChild(DashboardSalesPanelComponent) dashboardSalesPanelComponent!: DashboardSalesPanelComponent;
  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private router: Router,
    private agentService: AgentService,
    private dashboardService: DashboardService,
  ) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if (obj) {
      this.menuId = parseInt(obj['menuId']) ?? 0;
      this.menuUrl = obj['menuUrl'];
      this.canEdit = obj['canEdit'];
      this.editUrl = obj['editUrl'];
      this.id = parseInt(obj['id']);
      this.userId = obj['userId'];
      this.getFormData(this.id);
      this.GetAgentStatus();
    }
    this.agentForm = this.fb.group({
      agentFirstName: ['', [Validators.required]],
      agentLastName: ['', [Validators.required]],
      agentEmail: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      agentMobile: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      agentCountryCode: ['91', [Validators.required]],
      agentStatus: ['1', [Validators.required]],
      agentId: ['0'],
      agentDOB: ['', [Validators.required]],
      agentGender: ['', [Validators.required]],
      userId: ['0'],
      lastLogin: [''],
    });

    this.companyForm = this.fb.group({
      companyId: ['0'],
      companyName: ['', [Validators.required]],
      companyPancard: [
        '',
        [
          Validators.required,
          Validators.pattern('[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}'),
        ],
      ],
      companyGSTIN: ['', [Validators.required]],
      companyLicenseNo: ['', [Validators.required]],
      companyMobileNo: [
        '',
        [Validators.required, Validators.pattern('[0-9]{10}')],
      ],
      companyCountryCode: ['91', [Validators.required]],
      companyEmail: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      companyStreetAddress: ['', [Validators.required]],
      companyPincode: [
        '',
        [Validators.required, Validators.pattern('[0-9]{6}')],
      ],
      companyStateId: [''],
      companyState: ['', [Validators.required]],
      companyCityId: [''],
      companyCity: ['', [Validators.required]],
      companyStatus: ['1', [Validators.required]],
      userId: ['0'],
    });
    this.GetLeadsStatusDashboard();
  }
  get agentFormControl() {
    return this.agentForm.controls;
  }
  get companyDetailsFormControl() {
    return this.companyForm.controls;
  }
  ngOnInit(): void {}

  async getFormData(id: number) {
    const res = await this.adminService.GetAgentById(id);
    if (res != null && res.result) {
      this.agentForm.patchValue(res.result);
      this.companyForm.patchValue(res.result.companyDetails);
      this.documentsUploadForm = res.result.userDocuments;
      this.loginLogsComponent?.getLoginLogs(
        this.agentFormControl['userId']?.value,
        '',
      );
    } else {
      // swal.fire({
      //   position: 'center',
      //   icon: 'error',
      //   title: 'Something went wrong',
      //   showConfirmButton: false,
      //   timer: 3000,
      // });
    }
  }
  changeTab(tab: number) {
    this.activeTab = tab;
  }

  backBtClick() {
    this.router.navigateByUrl(this.editUrl, {
      state: {
        id: this.id,
        menuId: this.menuId,
        menuUrl: this.menuUrl,
        canEdit: this.canEdit,
        editUrl: this.editUrl,
      },
    });
  }

  homeBtClick() {
    this.router.navigateByUrl(this.menuUrl, {
      state: { menuId: this.menuId, menuUrl: this.menuUrl },
    });
  }

  ngAfterViewInit() {
    if (this.agentFormControl['userId']?.value > 0) {
      this.loginLogsComponent?.getLoginLogs(
        this.agentFormControl['userId'].value,
        '',
      ); //'4CBC43DAC4F4470BA73D3CF7C535B65C'); //this.generalService.getUniqueuserid());
    }
    this.bindLineChartDataPolicySold();
  }

  async GetAgentStatus() {
    let response = await this.agentService.GetAgentStatus(this.userId);
    if (response?.isSuccess && response?.result) {
      debugger;
      let agentStatuses = JSON.parse(response?.result);
      if (agentStatuses && agentStatuses.length > 0) {
        let obj = agentStatuses[0];
        let kycAvg = (obj.ADR_Status + obj.QUL_Status + obj.PAN_Status + obj.IMG_Status) / 4;
        let trainingAvg = (obj.TrainingSession1 + obj.TrainingSession2 + obj.TrainingSession3 + obj.TrainingSession4 + obj.TrainingSession5)/5;

        this.agentOnBoardingStatus.ADR_Status = obj.ADR_Status;
        this.agentOnBoardingStatus.QUL_Status = obj.QUL_Status;
        this.agentOnBoardingStatus.PAN_Status = obj.PAN_Status;
        this.agentOnBoardingStatus.IMG_Status = obj.IMG_Status;
        this.agentOnBoardingStatus.BNK_Status = obj.BNK_Status;
        this.agentOnBoardingStatus.TRN_Status = (trainingAvg > 0 && trainingAvg < 1) ? 2 : kycAvg;//obj.TRN_Status;
        this.agentOnBoardingStatus.EXM_Status = obj.EXM_Status;
        this.agentOnBoardingStatus.KYC_Status = (kycAvg > 0 && kycAvg < 1) ? 2 : kycAvg; // obj.KYC_Status
        this.agentOnBoardingStatus.TrainingSession1 = obj.TrainingSession1;
        this.agentOnBoardingStatus.TrainingSession2 = obj.TrainingSession2;
        this.agentOnBoardingStatus.TrainingSession3 = obj.TrainingSession3;
        this.agentOnBoardingStatus.TrainingSession4 = obj.TrainingSession4;
        this.agentOnBoardingStatus.TrainingSession5 = obj.TrainingSession5;
      }
    }
  }

  async DownloadCertificate(){
    let response = await this.agentService.DownloadCertificate(this.userId);
    if(response?.isSuccess && response?.result){
      const downloadLink = document.createElement('a');
      downloadLink.href = response.result;
      downloadLink.download = "Certificate.pdf";
      downloadLink.target = "_blank";
      downloadLink.click();
    }
  }


    today = new Date();
    selectedStartDate:any = moment(this.today).add(-7, 'days').format();
    selectedEndDate:any = this.today;
    selectedDateRange:string="Past 7 Days";
    isDateRangeChanged:boolean = false;
    //selectedAgentIds = "";
    policyTypeList:{text:string,value:number}[] = [{text:"Both",value:2},{text:"Offline",value:1},{text:"Online",value:0}];
    policyType:number = 0;
    async onPolicyTypeCheckOutput(event:any){
      this.policyType = event;
      this.bindLineChartDataPolicySold(true);
    }
  
    async onDateRangeChange(selectedValues:any) {
      if(selectedValues?.length > 0){
        let dataArray = selectedValues.split('::');
        if(dataArray?.length > 2){
          this.selectedStartDate = dataArray[0];
          this.selectedEndDate = dataArray[1];
          this.selectedDateRange = dataArray[2];
  
          this.isDateRangeChanged  = true;
          //this.selectedAgentIds = '';
          setTimeout(() => {
            this.bindLineChartDataPolicySold();
            this.GetLeadsStatusDashboard();
          }, 100);
        }
      }    
    }
  
    bindLineChartDataPolicySold(policyTypeCahnge=false){
      if(this.dashboardSalesPanelComponent != undefined){
        this.dashboardSalesPanelComponent.isDateRangeChanged = this.isDateRangeChanged;
        this.dashboardSalesPanelComponent.bindLineChartDataPolicySoldCall(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'),this.policyType,policyTypeCahnge,"","");
        this.isDateRangeChanged = false;
      }
    }

    GetLeadsStatusDashboard(){
      let obj={
        startDate:this.selectedStartDate,
        endDate:this.selectedEndDate,
        agentId: this.id.toString()
      }
      this.dashboardService.GetLeadsStatus(obj).then((response)=> { 
        if(response?.isSuccess && response?.result?.length > 30)
        {
          let obj = JSON.parse(response.result);
          if(obj?.length > 0)
          {
            this.totalLeads = obj[0].TotalLeads;
            this.succeedLeads = obj[0].SucceedLeads;
            this.failedLeads = obj[0].FailedLeads;
            this.pendingLeads = obj[0].PendingLeads;
          }
        }
      });
    }
}
